module.exports = __webpack_public_path__ + "img/adobe.b79076c9.svg";